import styled from "styled-components";


const StyledTopHeader = styled.div`
display: flex;
justify-content: center;
align-items: center;

@media ${props => props.theme.media.smallScreen}{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}
@media ${props => props.theme.media.tablet}{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
} 
@media ${props => props.theme.media.phone}{
    display: flex;
    flex-direction: column;
 }
`
const CurrencyTextTop = styled.p`
font-size: 16px;
color: #fff;
margin-left: 100px;
&:first-child {
    margin-left: 0;
}

@media ${props => props.theme.media.smallScreen}{
    margin: 0;
}
@media ${props => props.theme.media.tablet}{
    margin: 10px 0 0 0;
    font-size: 18px ;
} 
@media ${props => props.theme.media.phone}{
    margin: 10px 0 0 0;
    font-size: 18px ;
 }
`


const TopHeader = ({rateNow}) =>{

   
  
  
    return(
 
    
        <StyledTopHeader>
            {rateNow.map(item =>{
                let usd = item[24];
                let eur = item[31];
                let pln = item[32];
                let gbp = item[23];
               return(
            <>
                <CurrencyTextTop>{usd.cc} : {usd.rate}</CurrencyTextTop>
                <CurrencyTextTop >{eur.cc} : {eur.rate}</CurrencyTextTop>
                <CurrencyTextTop>{pln.cc} : {pln.rate}</CurrencyTextTop>
                <CurrencyTextTop>{gbp.cc} : {gbp.rate}</CurrencyTextTop>
            </>
        
               )
            })}
            
        </StyledTopHeader>
        
        
    )
}
export default TopHeader;

